import constants from 'common/constants'

import {
  ADD_BRANCH,
  CHECK_BRANCH_LIMIT,
  CONFIRM_BRANCH_BANNER_FILE_UPLOAD,
  CONFIRM_BRANCH_LOGO_FILE_UPLOAD,
  DELETE_BRANCH,
  DELETE_BRANCH_BANNER_FILE,
  DELETE_BRANCH_LOGO_FILE,
  GET_BRANCHES,
  GET_BRANCH_BANNER_SIGNED_UPLOAD_URL,
  GET_BRANCH_LOGO_SIGNED_UPLOAD_URL,
  UPDATE_BRANCH,
  VIEW_BRANCH,
} from './ActionTypes/ApiActionTypes'

export const getBranches = (data, onSuccess, onFailure) => {
  return {
    type: GET_BRANCHES,
    payload: {
      apiUrl: constants.api_get_active_branches,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const allBranches = (data, onSuccess, onFailure) => {
  return {
    type: GET_BRANCHES,
    payload: {
      apiUrl: constants.api_get_all_branches,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const deleteBranch = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_BRANCH,
    payload: {
      apiUrl: constants.api_delete_branch(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const addBranch = (data, onSuccess, onFailure) => {
  return {
    type: ADD_BRANCH,
    payload: {
      apiUrl: constants.api_add_branch,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const viewBranch = (id, onSuccess, onFailure) => {
  return {
    type: VIEW_BRANCH,
    payload: {
      apiUrl: constants.api_view_branch(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const deleteLogoFile = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_BRANCH_LOGO_FILE,
    payload: {
      apiUrl: constants.api_delete_branch_file(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const updateBranch = (id, data, onSuccess, onFailure) => {
  return {
    type: UPDATE_BRANCH,
    payload: {
      apiUrl: constants.api_update_branch(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getLogoSignedUrl = (body, onSuccess, onFailure) => {
  return {
    type: GET_BRANCH_LOGO_SIGNED_UPLOAD_URL,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_get_branch_logo_signed_upload_url,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: body,
    },
  }
}

export const confirmBranchLogoFileUpload = (body, onSuccess, onFailure) => {
  return {
    type: CONFIRM_BRANCH_LOGO_FILE_UPLOAD,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_confirm_branch_logo_file_upload,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: body,
    },
  }
}

export const getBannerSignedUrl = (body, onSuccess, onFailure) => {
  return {
    type: GET_BRANCH_BANNER_SIGNED_UPLOAD_URL,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_get_branch_banner_signed_upload_url,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: body,
    },
  }
}

export const confirmBannerFileUpload = (body, onSuccess, onFailure) => {
  return {
    type: CONFIRM_BRANCH_BANNER_FILE_UPLOAD,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_confirm_branch_banner_file_upload,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: body,
    },
  }
}

export const deleteBannerFile = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_BRANCH_BANNER_FILE,
    payload: {
      apiUrl: constants.api_delete_branch_banner_file(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const checkBranchLimit = (body, onSuccess, onFailure) => {
  return {
    type: CHECK_BRANCH_LIMIT,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_check_branch_limit,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: body,
    },
  }
}
